import { forwardRef } from 'react';
// @ts-ignore
import ImatgeComponent from 'components/corporatiu/Imatge/Imatge';
// @ts-ignore
import EnllacComponent from 'components/corporatiu/Enllac/Enllac';
import { LogotipsProps } from './Logotips.types';
import styles from './logotips.module.scss';

const Imatge = ImatgeComponent as React.ComponentType<{
    src?: string;
    alt?: string;
    width?: string | number;
    height?: string | number;
}>;

const Enllac = EnllacComponent as React.ComponentType<{
    href?: string;
    target?: string;
    children: React.ReactNode;
}>;

const LogotipsComponent = forwardRef<HTMLDivElement, LogotipsProps>((_, ref) => {
    return (
        <div ref={ref} className={styles.wrapper}>
            <h2>TV3</h2>
            <ul className={styles.logotips}>
                <li>
                    <div className={styles.imatgeLogotip}>
                        <Imatge
                            src='https://statics.3cat.cat/img/logos/tvc_colorBgBlanc.svg'
                            alt='Logotip de Televisió de Catalunya'
                            width='120'
                            height='60'
                        />
                    </div>
                    <h3>Televisió de Catalunya</h3>
                    <span className={styles.arxiusLogotips}>
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_tvc.jpg' target='_blank'>
                            normal
                        </Enllac>
                        |
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_tvc.zip' target='_blank'>
                            vectorial
                        </Enllac>
                    </span>
                </li>
                <li>
                    <div className={styles.imatgeLogotip}>
                        <Imatge
                            src='https://statics.3cat.cat/img/logos/tv3_colorBgBlanc.svg'
                            alt='Logotip TV3'
                            width='65'
                            height='53'
                        />
                    </div>
                    <h3>TV3</h3>
                    <span className={styles.arxiusLogotips}>
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_tv3.jpg' target='_blank'>
                            normal
                        </Enllac>
                        |
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_tv3.zip' target='_blank'>
                            vectorial
                        </Enllac>
                    </span>
                </li>
                <li>
                    <div className={styles.imatgeLogotip}>
                        <Imatge
                            src='https://statics.3cat.cat/img/logos/3CatInfo_negre.svg'
                            alt='Logotip 3CatInfo'
                            width='136'
                            height='28'
                        />
                    </div>
                    <h3>3CatInfo</h3>
                    <span className={styles.arxiusLogotips}>
                        <Enllac
                            href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_3CatInfo_jpg.zip'
                            target='_blank'
                        >
                            jpg
                        </Enllac>
                        |
                        <Enllac
                            href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_3CatInfo_png.zip'
                            target='_blank'
                        >
                            png
                        </Enllac>
                        |
                        <Enllac
                            href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_3CatInfo_pdf.zip'
                            target='_blank'
                        >
                            pdf
                        </Enllac>
                    </span>
                </li>
                <li>
                    <div className={styles.imatgeLogotip}>
                        <Imatge
                            src='https://statics.3cat.cat/img/logos/sx3_colorBgBlanc.svg'
                            alt='Logotip SX3'
                            width='90'
                            height='45'
                        />
                    </div>
                    <h3>SX3</h3>
                    <span className={styles.arxiusLogotips}>
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_SX3.jpg' target='_blank'>
                            normal
                        </Enllac>
                        |
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_SX3.zip' target='_blank'>
                            vectorial
                        </Enllac>
                    </span>
                </li>
                <li>
                    <div className={styles.imatgeLogotip}>
                        <Imatge
                            src='https://statics.3cat.cat/img/logos/s3_colorBgBlanc.svg'
                            alt='Logotip S3'
                            width='60'
                            height='45'
                        />
                    </div>
                    <h3>S3</h3>
                    <span className={styles.arxiusLogotips}>
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_S3.jpg' target='_blank'>
                            normal
                        </Enllac>
                        |
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_S3.zip' target='_blank'>
                            vectorial
                        </Enllac>
                    </span>
                </li>
                <li>
                    <div className={styles.imatgeLogotip}>
                        <Imatge
                            src='https://statics.3cat.cat/img/logos/x3_colorBgBlanc.svg'
                            alt='Logotip X3'
                            width='70'
                            height='45'
                        />
                    </div>
                    <h3>X3</h3>
                    <span className={styles.arxiusLogotips}>
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_X3.jpg' target='_blank'>
                            normal
                        </Enllac>
                        |
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_X3.zip' target='_blank'>
                            vectorial
                        </Enllac>
                    </span>
                </li>
                <li>
                    <div className={styles.imatgeLogotip}>
                        <Imatge src='https://statics.3cat.cat/img/logos/33.svg' alt='Logotip 33' width='65' height='50' />
                    </div>
                    <h3>33</h3>
                    <span className={styles.arxiusLogotips}>
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_33.jpg' target='_blank'>
                            normal
                        </Enllac>
                        |
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_33.zip' target='_blank'>
                            vectorial
                        </Enllac>
                    </span>
                </li>
                <li>
                    <div className={styles.imatgeLogotip}>
                        <Imatge
                            src='https://statics.3cat.cat/img/logos/esport3_simbol_color.svg'
                            alt='Logotip Esport3'
                            width='70'
                            height='42'
                        />
                    </div>
                    <h3>Esport3</h3>
                    <span className={styles.arxiusLogotips}>
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_esport3.jpg' target='_blank'>
                            normal
                        </Enllac>
                        |
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_esport3.zip' target='_blank'>
                            vectorial
                        </Enllac>
                    </span>
                </li>
                <li>
                    <div className={styles.imatgeLogotip}>
                        <Imatge
                            src='https://statics.3cat.cat/img/logos/tv3cat_colorBgBlanc.svg'
                            alt='Logotip TV3CAT'
                            width='95'
                            height='48'
                        />
                    </div>
                    <h3>TV3CAT</h3>
                    <span className={styles.arxiusLogotips}>
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_tv3cat.jpg' target='_blank'>
                            normal
                        </Enllac>
                        |
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_tv3cat.zip' target='_blank'>
                            vectorial
                        </Enllac>
                    </span>
                </li>
                <li>
                    <div className={styles.imatgeLogotip}>
                        <Imatge
                            src='https://statics.3cat.cat/img/logos/logo_tv3hd_color.svg'
                            alt='Logotip TV3HD'
                            width='100'
                            height='46'
                        />
                    </div>
                    <h3>TV3HD</h3>
                    <span className={styles.arxiusLogotips}>
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_tv3hd.jpg' target='_blank'>
                            normal
                        </Enllac>
                        |
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_tv3hd.zip' target='_blank'>
                            vectorial
                        </Enllac>
                    </span>
                </li>
            </ul>
            <div className={styles.infoContacte}>
                <h3>Màrqueting Televisió de Catalunya</h3>
                <span>Tel. 93 499 96 55</span>
            </div>
            <h2>Catalunya Ràdio</h2>
            <ul className={styles.logotips}>
                <li>
                    <div className={styles.imatgeLogotip}>
                        <Imatge
                            src='https://statics.3cat.cat/img/logos/catradio_colorBgBlanc.svg'
                            alt='Logotip Catalunya Ràdio'
                            width='70'
                            height='65'
                        />
                    </div>
                    <h3>Catalunya Ràdio</h3>
                    <span className={styles.arxiusLogotips}>
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/Catradio_JPG.zip' target='_blank'>
                            jpg
                        </Enllac>
                        |
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/Catradio_PNG.zip' target='_blank'>
                            png
                        </Enllac>
                        |
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/Catradio_PDF.zip' target='_blank'>
                            pdf
                        </Enllac>
                    </span>
                </li>
                <li>
                    <div className={styles.imatgeLogotip}>
                        <Imatge
                            src='https://statics.3cat.cat/img/logos/3CatInfo_negre.svg'
                            alt='Logotip 3CatInfo'
                            width='136'
                            height='28'
                        />
                    </div>
                    <h3>3CatInfo</h3>
                    <span className={styles.arxiusLogotips}>
                        <Enllac
                            href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_3CatInfo_jpg.zip'
                            target='_blank'
                        >
                            jpg
                        </Enllac>
                        |
                        <Enllac
                            href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_3CatInfo_png.zip'
                            target='_blank'
                        >
                            png
                        </Enllac>
                        |
                        <Enllac
                            href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_3CatInfo_pdf.zip'
                            target='_blank'
                        >
                            pdf
                        </Enllac>
                    </span>
                </li>
                <li>
                    <div className={styles.imatgeLogotip}>
                        <Imatge
                            src='https://statics.3cat.cat/img/logos/catmusica_colorBgBlanc.svg'
                            alt='Logotip Catalunya Música'
                            width='110'
                            height='35'
                        />
                    </div>
                    <h3>Catalunya Música</h3>
                    <span className={styles.arxiusLogotips}>
                        <Enllac
                            href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_cat_musica.jpg'
                            target='_blank'
                        >
                            normal
                        </Enllac>
                        |
                        <Enllac
                            href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_cat_musica.zip'
                            target='_blank'
                        >
                            vectorial
                        </Enllac>
                    </span>
                </li>
                <li>
                    <div className={styles.imatgeLogotip}>
                        <Imatge
                            src='https://statics.3cat.cat/img/logos/icat_colorBgBlanc.svg'
                            alt='Logotip iCat'
                            width='45'
                            height='45'
                        />
                    </div>
                    <h3>iCat</h3>
                    <span className={styles.arxiusLogotips}>
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_icat.jpg' target='_blank'>
                            normal
                        </Enllac>
                        |
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_icat.zip' target='_blank'>
                            vectorial
                        </Enllac>
                    </span>
                </li>
            </ul>
            <div className={styles.infoContacte}>
                <h3>Màrqueting Catalunya Ràdio</h3>
                <span>Tel. 93 306 92 00</span>
            </div>
            <h2>Corporació Catalana de Mitjans Audiovisuals (ens)</h2>
            <ul className={styles.logotips}>
                <li>
                    <div className={styles.imatgeLogotip}>
                        <Imatge
                            src='https://statics.3cat.cat/img/logos/ccma_VcolorBgBlanc.svg'
                            alt='Logotip CCMA vertical'
                            width='110'
                            height='34'
                        />
                    </div>
                    <h3>
                        CCMA
                        <br />
                        (aplicació vertical)
                    </h3>
                    <span className={styles.arxiusLogotips}>
                        <Enllac
                            href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_ccma_vertical.jpg'
                            target='_blank'
                        >
                            normal
                        </Enllac>
                        |
                        <Enllac
                            href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_ccma_vertical.zip'
                            target='_blank'
                        >
                            vectorial
                        </Enllac>
                    </span>
                </li>
                <li>
                    <div className={styles.imatgeLogotip}>
                        <Imatge
                            src='https://statics.3cat.cat/img/logos/ccma_colorBgBlanc.svg'
                            alt='Logotip CCMA hortizontal'
                            width='110'
                            height='25'
                        />
                    </div>
                    <h3>
                        CCMA
                        <br />
                        (aplicació horitzontal)
                    </h3>
                    <span className={styles.arxiusLogotips}>
                        <Enllac
                            href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_ccma_horitzontal.jpg'
                            target='_blank'
                        >
                            normal
                        </Enllac>
                        |
                        <Enllac
                            href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_ccma_horitzontal.zip'
                            target='_blank'
                        >
                            vectorial
                        </Enllac>
                    </span>
                </li>
                <li>
                    <div className={styles.imatgeLogotip}>
                        <Imatge
                            src='https://statics.3cat.cat/img/logos/ccma_CcolorBgBlanc.svg'
                            alt='Logotip CCMA central'
                            width='110'
                            height='54'
                        />
                    </div>
                    <h3>
                        CCMA
                        <br />
                        (aplicació central)
                    </h3>
                    <span className={styles.arxiusLogotips}>
                        <Enllac
                            href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_ccma_centrat.jpg'
                            target='_blank'
                        >
                            normal
                        </Enllac>
                        |
                        <Enllac
                            href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_ccma_centrat.zip'
                            target='_blank'
                        >
                            vectorial
                        </Enllac>
                    </span>
                </li>
            </ul>
            <h2>3Cat</h2>
            <ul className={styles.logotips}>
                <li>
                    <div className={styles.imatgeLogotip}>
                        <Imatge
                            src='https://statics.3cat.cat/recursos/ccma/premsa/arxius/minilogo_3cat.png'
                            alt='Logotip 3Cat'
                            width='158'
                            height='78'
                        />
                    </div>
                    <h3>3Cat</h3>
                    <span className={styles.arxiusLogotips}>
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_3cat_jpg.zip' target='_blank'>
                            jpg
                        </Enllac>
                        |
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_3cat_png.zip' target='_blank'>
                            png
                        </Enllac>
                        |
                        <Enllac
                            href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_3cat_vectorial.zip'
                            target='_blank'
                        >
                            pdf
                        </Enllac>
                    </span>
                </li>
                <li>
                    <div className={styles.imatgeLogotip}>
                        <Imatge
                            src='https://statics.3cat.cat/recursos/ccma/premsa/arxius/minilogo_3cat_horitzontal.jpg'
                            alt='Logotip 3Cat+mitjans horitzontal'
                            width='158'
                            height='78'
                        />
                    </div>
                    <h3>
                        3Cat + mitjans
                        <br />
                        (aplicació horitzontal)
                    </h3>
                    <span className={styles.arxiusLogotips}>
                        <Enllac
                            href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_3cat_horitzontal_jpg.zip'
                            target='_blank'
                        >
                            jpg
                        </Enllac>
                        |
                        <Enllac
                            href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_3cat_horitzontal_png.zip'
                            target='_blank'
                        >
                            png
                        </Enllac>
                        |
                        <Enllac
                            href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_3cat_horitzontal_vectorial.zip'
                            target='_blank'
                        >
                            pdf
                        </Enllac>
                    </span>
                </li>
                <li>
                    <div className={styles.imatgeLogotip}>
                        <Imatge
                            src='https://statics.3cat.cat/recursos/ccma/premsa/arxius/minilogo_3cat_vertical.jpg'
                            alt='Logotip 3cat+mitjans vertical'
                            width='158'
                            height='78'
                        />
                    </div>
                    <h3>
                        3Cat + mitjans
                        <br />
                        (aplicació vertical)
                    </h3>
                    <span className={styles.arxiusLogotips}>
                        <Enllac
                            href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_3cat_vertical_jpg.zip'
                            target='_blank'
                        >
                            jpg
                        </Enllac>
                        |
                        <Enllac
                            href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_3cat_vertical_png.zip'
                            target='_blank'
                        >
                            png
                        </Enllac>
                        |
                        <Enllac
                            href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/logotip_3cat_vertical_vectorial.zip'
                            target='_blank'
                        >
                            pdf
                        </Enllac>
                    </span>
                </li>
            </ul>
            <div className={styles.infoContacte}>
                <h3>Comunicació CCMA</h3>
                <span>Tel. 93 444 48 00</span>
            </div>
            <h2>EVA</h2>
            <ul className={styles.logotips}>
                <li>
                    <div className={styles.imatgeLogotip}>
                        <Imatge
                            src='https://statics.3cat.cat/recursos/3cat/logos/web/eva_negre.svg'
                            alt='Logotip EVA'
                            width='95'
                            height='42'
                        />
                    </div>
                    <h3>EVA</h3>
                    <span className={styles.arxiusLogotips}>
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/EVA_JPG.zip' target='_blank'>
                            jpg
                        </Enllac>
                        |
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/EVA_PNG.zip' target='_blank'>
                            png
                        </Enllac>
                        |
                        <Enllac href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/EVA_PDF.zip' target='_blank'>
                            pdf
                        </Enllac>
                    </span>
                </li>
            </ul>
            <h2>Fundació La Marató</h2>
            <ul className={styles.logotips}>
                <li>
                    <div className={styles.imatgeLogotip}>
                        <Imatge
                            src='https://statics.3cat.cat/recursos/marato/img/logos/logo-fundacio30.svg'
                            alt='Logotip Fundació La Marató'
                            width='130'
                            height='38'
                        />
                    </div>
                    <h3>Fundació La Marató</h3>
                    <span className={styles.arxiusLogotips}>
                        <Enllac
                            href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/Fundacio-La-Marato-3Cat_JPG.zip'
                            target='_blank'
                        >
                            jpg
                        </Enllac>
                        |
                        <Enllac
                            href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/Fundacio-La-Marato-3Cat_PNG.zip'
                            target='_blank'
                        >
                            png
                        </Enllac>
                        |
                        <Enllac
                            href='https://statics.3cat.cat/recursos/ccma/premsa/arxius/Fundacio-La-Marato-3Cat_PDF.zip'
                            target='_blank'
                        >
                            pdf
                        </Enllac>
                    </span>
                </li>
            </ul>
            <div className={styles.infoContacte}>
                <h3>Comunicació Fundació La Marató:</h3>
                <span>Tel. 93 444 48 30</span>
            </div>
        </div>
    );
});

LogotipsComponent.displayName = 'LogotipsComponent';
export default LogotipsComponent;
